/**
 * Fetch response.
 */
const productFetch = async (endPoint, data = {}) => {
	try {
		const response = await fetch(`${dcRestSettings.endpoint}${endPoint}`, data);

		if (!response.ok) {
			console.log(`Uh Oh! Status Code: ${response.status}`);
			return;
		}

		return await response.json();
	} catch (error) {
		// Catches errors both in fetch and response.json
		console.log(error);
	}
};

const getTableImage = async (itemId, tableItemSlug) => {
	const dcImageResponse = await fetch(`${dcRestSettings.endpoint}party-reflections/v1/dc_table_item/${itemId}/${tableItemSlug}`);

	if (!dcImageResponse.ok) {
		console.log(`getTableImage. Status Code: ${dcImageResponse.status}. If this is 404, that's okay. It just means the last page has been reached.`);
		return;
	}

	return dcImageResponse.json();
};

export default productFetch;
export { getTableImage };
